import { UserRoleEnum } from 'enums'

export const getUserRoleLabel = (userRole: UserRoleEnum) => {
  switch (userRole) {
    case UserRoleEnum.ADMIN:
      return 'Platform Admin'
    case UserRoleEnum.TENANT_ADMIN:
      return 'Admin'
    case UserRoleEnum.TENANT_USER:
      return 'User'
  }
}
